// Grok and DeepSeek write bare [1][2] footnotes with no link behind them, so Sources carries the URLs.
const BARE_MARKER = / ?\[\d{1,3}\](?!\()/g // the leading space goes with the marker, so no double space survives

export function stripCitationMarkers(text: string): string {
  if (!text.includes('[')) return text

  return text.replace(BARE_MARKER, '')
}
